import React from 'react'
import { SVGShipping2, SVGShippingCar, SVGPackage, SVGIconLink, SVGDropPackage } from './SVGCollection';
import PageLink from './PageLink';

import cn from 'classnames'
import cg from 'Scss/app.scss'
import cl from 'Scss/pages/Product.scss'
import { shippingMethods_shippingMethods, getCheckoutInfo_shippingMethods } from 'Utils/api/gql/types'
import { priceIntervalFormatter } from 'Utils/helpers/formatters';
import { isNull } from 'util';
import { connect } from 'react-redux';

type ReduxProps = {
    shippingMethods: getCheckoutInfo_shippingMethods[]
}

type Props = {
    isMpl: boolean
}

class ProductPageShipping extends React.Component<Props & ReduxProps> {
    private renderGRoby(shippingMethod: shippingMethods_shippingMethods | null | undefined) {
        if (!shippingMethod) {
            return ''
        }
        return (
            <div className={cn(cl.deliveryPossibility)}>
                <SVGShippingCar width={32} height={32} />
                GRoby futárral Budapestre és környékére szállítható<br />
                <strong>{priceIntervalFormatter(shippingMethod.price)}</strong>
            </div>
        )
    }

    private renderMpl(shippingMethod: shippingMethods_shippingMethods | null | undefined) {
        if (!shippingMethod) {
            return ''
        }
        return (
            <div className={cn(cl.deliveryPossibility)}>
                <SVGShipping2 width={32} height={32} />
                Csomagfutárral az ország egész területére szállítható!<br />
                <strong>{priceIntervalFormatter(shippingMethod.price)}</strong>
            </div>
        )
    }

    private renderPostPoint(shippingMethod: shippingMethods_shippingMethods | null | undefined) {
        if (!shippingMethod) {
            return ''
        }
        return (
            <div className={cn(cl.deliveryPossibility)}>
                <SVGDropPackage width={32} height={32} />
                Az ország összes PostaPontján átvehető!<br />
                <strong>{priceIntervalFormatter(shippingMethod.price)}</strong>
            </div>
        )
    }

    private renderGPoint(shippingMethod: shippingMethods_shippingMethods | null | undefined) {
        if (!shippingMethod) {
            return ''
        }
        return (
            <div className={cn(cl.deliveryPossibility)}>
                <SVGPackage width={32} height={32} />
                Személyesen másnap átvehető
                <span className={cn(cl.address)}>
                <a href="https://goo.gl/maps/N4f5sTbKTyo" target="_blank">
                    1186 Budapest, Közdűlő út 46-50.
                </a>
                </span>
                <br />
                <strong>{priceIntervalFormatter(shippingMethod.price)}</strong>
            </div>
        )
    }

    public render() {
        const { shippingMethods } = this.props
        if (shippingMethods) {
            const GRoby = shippingMethods.find(method => !isNull(method) && method.__typename === 'ShippingMethodGRoby')
            const Mpl = shippingMethods.find(method => !isNull(method) && method.__typename === 'ShippingMethodMpl')
            const PostPoint = shippingMethods.find(method => !isNull(method) && method.__typename === 'ShippingMethodPostPoint')
            const GPoint = shippingMethods.find(method => !isNull(method) && method.__typename === 'ShippingMethodGPoint')

            return (
                <div className={cn(cg.cell, cg.large7)}>
                <div className={cn(cl.deliveryInformation)}>
                  {this.renderGRoby(GRoby)}
                  {this.props.isMpl && (
                      <>
                        {this.renderMpl(Mpl)}
                        {this.renderPostPoint(PostPoint)}
                      </>
                  )}
                  {this.renderGPoint(GPoint)}
                  <PageLink toPage='/szallitas' className={cn(cl.pageLink)}>
                    További szállítási információk
                    <SVGIconLink width={18} height={18} />
                  </PageLink>
                </div>
              </div>
            )
        }
    }
}


export default connect<ReduxProps, {}, {}, Redux.IReduxState>(({ checkoutInfo }) =>
  ({
    shippingMethods: checkoutInfo.shippingMethods
  })
)(ProductPageShipping)
